import React, { useState,useEffect,useRef } from "react";
import { Container, Row, Col, Button, Form, Modal, Table, Alert, Badge } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { validatePhone,number_format,validateDecimalNumber } from "./utils";
import { getDataDb, setDataDb, deleteDataDb } from "../http/petitions";
import { cloudService, downloadPoliza } from "../http/http.services";
import { useSelector,useDispatch } from 'react-redux';
import { 
  setStateHome,
  setStateHomeDataRecibo,
  setStateHomeRecibo,
  marcarPagoRecibo,
  updatePrimaNetaRecibo,
  updateStatusRecibo,
  updateStatusEndoso,
  actualizarEndoso,
  showAlert,
  updateContrato, 
  updateContratoObservaciones,
  quitarPagoRecibo} from "../reducers/appReducer";
import moment from "moment";

const ModalFilter = ({ show, handleClose }) => {

  const [state, setState] = useState({
    section: 1,
    search_input: '',
    dataRamos: [],
    dataCompanias: [],
    dataAgentes: [],
  })

  const handleSetSection = (section) => setState({ ...state, section: section });

  return (
    <Modal show={show} onHide={handleClose} size="lg" fullscreen={false}>
      <Modal.Header closeButton>
        <Modal.Title>FILTRAR POR</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">

                <ul className="nav nav-pills mb-3">
                  <li className="nav-item">
                    <a className={`nav-link ${(state.section === 1) && 'active'}`} aria-current="page" href="#" onClick={() => handleSetSection(1)}>Ramos</a>
                  </li>
                  <li className="nav-item ms-2">
                    <a className={`nav-link ${(state.section === 2) && 'active'}`} aria-current="page" href="#" onClick={() => handleSetSection(2)}>Compañias</a>
                  </li>
                  <li className="nav-item ms-2">
                    <a className={`nav-link ${(state.section === 3) && 'active'}`} aria-current="page" href="#" onClick={() => handleSetSection(3)}>Agentes</a>
                  </li>
                </ul>

                <form action="" className="d-flex flex-column align-items-end flex-md-row mt-3 gap-2 mb-3">
                  <div className="container-fluid p-0">
                    <div className="row">
                      <div className="col-12 col-md-9">
                        <div className="form-group group-search mb-1">
                          <i className="bi bi-search pe-2"></i>
                          <input
                            type="search"
                            className="form-control ws-input-search"
                            placeholder="Filtrar por ramo, compañia o agente"
                            value={state.search_input}
                            onChange={(e) => setState({ ...state, search_input: e.target.value })} />
                        </div>
                      </div>
                      <div className="col-12 col-md-3">
                        <div className="form-group mb-1">
                          <button className="btn btn-primary ws-btn-blue-2"><i className="bi bi-search pe-2"></i> Buscar</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <button className="btn btn-light mb-3">Buscar pagos cotejados</button>

                {
                  (state.section === 1) && (
                    <React.Fragment>
                      <div className="bg-light border rounded-1 p-2">
                        <p className='mb-0'> <i className='bi bi-info-circle-fill' style={{ color: '#777' }}></i> SELECCIONA LOS RAMOS QUE DESEAS FILTRAR PARA OBTENER RESULTADOS.</p>
                      </div>
                      <Table hover className="mt-3 mb-3">
                        <thead>
                          <tr>
                            <th width="10%">
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-1" />
                              </div>
                            </th>
                            <th width="90%">Ramo</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-1" />
                              </div>
                            </td>
                            <td>Autos</td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-2" />
                              </div>
                            </td>
                            <td>GMM</td>
                          </tr>
                        </tbody>
                      </Table>
                    </React.Fragment>
                  )
                }

                {
                  (state.section === 2) && (
                    <React.Fragment>
                      <div className="bg-light border rounded-1 p-2">
                        <p className='mb-0'> <i className='bi bi-info-circle-fill' style={{ color: '#777' }}></i> SELECCIONA LAS COMPAÑÍAS QUE DESEAS FILTRAR PARA OBTENER RESULTADOS.</p>
                      </div>
                      <Table hover className="mt-3 mb-3">
                        <thead>
                          <tr>
                            <th width="10%">
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-1" />
                              </div>
                            </th>
                            <th width="90%">Compañia</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-1" />
                              </div>
                            </td>
                            <td>SEGUROS EL POTOSI</td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-2" />
                              </div>
                            </td>
                            <td>QUÁLITAS COMPAÑIAS DE SEGUROS</td>
                          </tr>
                        </tbody>
                      </Table>
                    </React.Fragment>
                  )
                }

                {
                  (state.section === 3) && (
                    <React.Fragment>
                      <div className="bg-light border rounded-1 p-2">
                        <p className='mb-0'> <i className='bi bi-info-circle-fill' style={{ color: '#777' }}></i> SELECCIONA LOS AGENTES QUE DESEAS FILTRAR PARA OBTENER RESULTADOS.</p>
                      </div>
                      <Table hover className="mt-3 mb-3">
                        <thead>
                          <tr>
                            <th width="10%">
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-1" />
                              </div>
                            </th>
                            <th width="90%">Agente</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-1" />
                              </div>
                            </td>
                            <td>(60004) TONO RAMIRO</td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-2" />
                              </div>
                            </td>
                            <td>(561424) JOSE ANTONIO RAMIRO</td>
                          </tr>
                        </tbody>
                      </Table>
                    </React.Fragment>
                  )
                }

              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary ws-btn-blue-2"><i className="bi bi-search pe-2"></i> Buscar</button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalEditPrimas = ({ show, handleClose,reload }) => {

  const refInputPrima = useRef(null);

  const stateHome = useSelector( (state) => state.agents.home );
  const dispatch = useDispatch();
  const { section, arrContrato } = stateHome;

  let numeroPoliza = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.numero_poliza : '';
  let arrFrom;
  if(section===1) arrFrom = 'arrPorPagar'
  if(section===2) arrFrom = 'arrPagados'
  if(section===3) arrFrom = 'arrVencidos'
  if(section===4) arrFrom = 'arrRenovaciones'
  let dataRecibo = stateHome[arrFrom].filter( element => element.numero_poliza == numeroPoliza);
  let primaNeta = (dataRecibo.length>0) ? dataRecibo[0].prima_neta : '';

  const [state, setState] = useState({
    error: false,
    isLoading: false,
  })

  const handleSubmitForm = () => {

    const primaNeta = refInputPrima.current.value;
    setState({ ...state, isLoading: true });

    if(primaNeta === '') {
      setState({ ...state, error: true });
      return false;
    }

    setState({ ...state, isLoading: true })
    //Guardar datos
    const formData =  new FormData();
    formData.append('valor',primaNeta);
    formData.append('id_contrato',dataRecibo[0].id_contrato);
    formData.append('id_usuario',dataRecibo[0].id_usuario);
    setDataDb(formData,'directoryController','setPrimasContrato')
    .then( response => {
      dispatch( updatePrimaNetaRecibo({
        section : arrFrom,
        poliza: numeroPoliza,
        primaNeta : parseFloat(primaNeta)
      }) )
      toast.success( (e) => (
        <p className="mb-0">Datos guardados correctamente</p>
      ),{
        duration: 2000
      });
      handleClose();
      setState({ ...state, isLoading: false })
      console.log(response);
    })

  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="sm"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Editar Primas</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">
                <Form className="mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Prima Neta (requerido)</Form.Label>
                    <Form.Control
                      ref={refInputPrima}
                      placeholder="Ingresa la prima neta"
                      defaultValue={parseFloat(primaNeta)}
                      onChange={(e) => {
                        validateDecimalNumber(e)
                        // setState({ ...state, prima: e.target.value })
                      }} />
                  </Form.Group>
                  {
                    (state.error) && (
                      <Alert variant='danger'>
                        <i className='bi bi-exclamation-triangle-fill'></i> Ingresa una prima neta
                      </Alert>
                    )
                  }
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button className="ws-btn-blue-2" onClick={handleSubmitForm} disabled={state.isLoading}>
          <i className="bi bi-check-circle-fill"></i> {state.isLoading ? 'Guardando' : 'Guardar'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalEndosos = ({ show, handleClose, reload }) => {

  const stateHome = useSelector( (state) => state.agents.home );
  const dispatch = useDispatch();
  const { section,arrContrato } = stateHome;
  const { contratos = [] } = arrContrato;

  let numeroPoliza = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.numero_poliza : '';
  let arrFrom;
  if(section===1) arrFrom = 'arrPorPagar'
  if(section===2) arrFrom = 'arrPagados'
  if(section===3) arrFrom = 'arrVencidos'
  if(section===4) arrFrom = 'arrRenovaciones'
  let dataRecibo = stateHome[arrFrom].filter( element => element.numero_poliza == numeroPoliza);

  let numeroEndosoRef = useRef(null);
  let fechaEndosoRef = useRef(null);
  let totalEndosoRef = useRef(null);
  let selectReciboInicialRef = useRef(null);
  let observacionEndosoRef = useRef(null);

  const [state, setState] = useState({
    isEndoso: false,
    isLoading: false,
    error: false,
    errorMessage: '',
  })

  const handleClickSetEndoso = () => setState({ ...state, isEndoso: !state.isEndoso });

  const submitForm = () => {
    var formData = new FormData();
    let totalEndoso = (totalEndosoRef.current!=null) ? totalEndosoRef.current.value : '0';
    formData.append('id_usuario',dataRecibo[0].id_usuario);
    formData.append('id_contrato',dataRecibo[0].id_contrato);
    formData.append('numero',numeroEndosoRef.current.value);
    formData.append('finicio',fechaEndosoRef.current.value);
    formData.append('ispay',state.isEndoso);
    formData.append('total',totalEndoso);
    formData.append('numerorecibo',selectReciboInicialRef.current.value);
    formData.append('observacion',observacionEndosoRef.current.value);
    formData.append('maxRecibos',contratos.length);
    setDataDb(formData,'directoryController','setRegisterEndoso')
    .then( response => {
      setState( {...state,isEndoso:false} )
      dispatch( actualizarEndoso( response ) )
      dispatch( showAlert( {
        show : true, 
        message : 'Endoso registrado correctamente'
      } ) )
      handleClose();
    })
  }

  const handleSaveEndoso = () => {
    if (numeroEndosoRef.current.value.trim() === '') {
      setState({ ...state, error: true, errorMessage: 'Ingresa el número del endoso' });
      return false;
    }
    if(fechaEndosoRef.current.value.trim() === ''){
      setState({ ...state, error: true, errorMessage: 'Ingresa la fecha del endoso' });
      return false;
    }
    if(state.isEndoso){
      if(totalEndosoRef.current!=null){
        if(totalEndosoRef.current.value.trim() === ''){
          setState({ ...state, error: true, errorMessage: 'Ingresa el total del endoso'});
          return false;
        }
      }
    }
    if(selectReciboInicialRef.current.value === ''){
      setState({ ...state, error: true, errorMessage: 'Selecciona el recibo inicial'});
      return false;
    }
    setState({ ...state, error: false,isLoading: false });
    submitForm();
  }

  return(
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Registrar Endoso</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">

                <Form className="mb-3">
                  <p className="text-secondary">Historial de pagos de endosos a realizar</p>
                  <Form.Group className="mb-3">
                    <Form.Label>Endoso (requerido)</Form.Label>
                    <Form.Control 
                    ref={numeroEndosoRef}
                    placeholder="Número del endoso" 
                    defaultValue=""
                    onChange={ (e) => {
                      validatePhone(e)
                    } } />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Fecha (requerido)</Form.Label>
                    <Form.Control 
                    ref={fechaEndosoRef}
                    type="date" 
                    defaultValue=""
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formEndoso">
                    <Form.Check 
                    type="checkbox" 
                    label="Este endoso tiene cobro" 
                    checked={state.isEndoso} 
                    onChange={handleClickSetEndoso} />
                  </Form.Group>
                  {
                    state.isEndoso && (
                      <Form.Group className="mb-3">
                        <Form.Control 
                        ref={totalEndosoRef}
                        placeholder="Ingresa el total del endoso (requerido)" 
                        defaultValue=""
                        onChange={ (e) => {
                          validateDecimalNumber(e)
                          // validatePhone(e)
                        } }
                        />
                      </Form.Group>
                    )
                  }

                  <Form.Group className="mb-3">
                    <Form.Label>Selecciona su recibo inicial</Form.Label>
                    <Form.Select ref={selectReciboInicialRef} defaultValue={'1'}>
                      {
                        contratos.map( (t,e) => {
                          let index = e+1;
                          return(
                            <option value={index}>{index}</option>
                          )
                        })
                      }
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control 
                    ref={observacionEndosoRef}
                    rows="5" 
                    as="textarea" 
                    placeholder="Agrega una observación a este endoso (opcional)"
                    defaultValue=""
                    />
                  </Form.Group>
                </Form>

                {
                  (state.error) && (
                    <Alert variant='danger'>
                      <i className='bi bi-exclamation-triangle-fill'></i> {state.errorMessage}
                    </Alert>
                  )
                }

              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button 
        className="ws-btn-blue-2" 
        onClick={ handleSaveEndoso }
        disabled={ state.isLoading }
        >
          <i className="bi bi-check-circle-fill"></i> { (state.isLoading) ? 'Registrando' : 'Registrar' }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalEditarPagoEndoso = ({show,handleClose,num_endoso,data,reload}) => {

  const { endoso,id_cobro, id_endoso } = data;

  const inputPagoRef =  useRef(null);
  const [state,setState] = useState({
    btnUpdateLoading: false,
  })

  const handleSubmitForm = (e) => {
    e.preventDefault();
    setState( prevState => ({ ...prevState, btnUpdateLoading: true }))
    if(inputPagoRef.current.value === ''){
      alert('Agrega una cantidad')
      return false;
    }

    const formData = new FormData();
    formData.append('id_cobro',id_cobro);
    formData.append('pago',inputPagoRef.current.value);
    formData.append('id_endoso',id_endoso)

    setDataDb(formData,'directoryController','setModifyReciboEndoso')
    .then( response => {
      reload(num_endoso,id_endoso);
      handleClose();
      setState( prevState => ({ ...prevState, btnUpdateLoading: false }))
      console.log('response editar pago endoso',response)
    })

  }

  return(
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Editar Pago</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Form onSubmit={handleSubmitForm}>
          <Form.Label>Cantidad</Form.Label>
          <Form.Control 
          ref={inputPagoRef} 
          defaultValue={endoso}
          className="mb-2" 
          type="text" 
          placeholder="Ingresa la cantidad del pago" 
          onChange={ (e) => validateDecimalNumber(e) }
          required />
          <Button type="submit" className="ws-btn-blue-2" disabled={state.btnUpdateLoading}>
            {(state.btnUpdateLoading) ? 'Actualizando...' : 'Actualizar'}
          </Button>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button className="ws-btn-blue-2" onClick={handleClose}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalVisualizarEndoso = ({ idEndoso,show, handleClose,data,endoso,isLoading,reload }) => {
  const dispatch = useDispatch();
  const inputFileRef = useRef(null);
  const [state, setState] = useState({
    isLoadingPanel: false,
    dataEndoso: {
      lista: [],
      nube: [],
      observacion: '',
      service: '',
      total:''
    },
    modalEditarPagoEndoso: false,
    dataEndosoSelected: {},
    isUploadButton: false
  })

  useEffect(()=> {
    setState({ ...state, dataEndoso: data})
  },[data])

  const handleUploadFile = (file) => {
    setState({ ...state, isUploadButton: true });
    console.log('Archivo:',file.target.files[0]);
    var formData = new FormData();
    formData.append('image', file.target.files[0]);
    cloudService(formData,`archivoEndoso&id_poliza=${idEndoso}`)
    .then( response => {
      inputFileRef.current.value = "";
      setState( { 
        ...state, 
        isUploadButton: false, 
        dataEndoso : {
          ...dataEndoso, 
          nube: response.nube  
        } });
      dispatch( showAlert({
        show: true,
        message: 'Tu archivo se ha subido con éxito'
      }) )
    })
  }

  const handleDownloadFile =  (id_subida) => {
    var formData = new FormData();
    formData.append('id_subida',id_subida);
    cloudService(formData,'goToDownloadPoliza')
    .then( response => {
      window.open(response,'_blank').focus();
    } )
  } 

  const handleDeletePoliza=  (id_subida) => {
    var formData = new FormData();
    formData.append('id_subida',id_subida);
    cloudService(formData,`goToDeletePoliza&id_poliza=${idEndoso}`,'endosos')
    .then( response => {
      setState( { 
        ...state, 
        isUploadButton: false, 
        dataEndoso : {
          ...dataEndoso, 
          nube: response.nube  
        } });
      dispatch( showAlert({
        show: true,
        message: 'El archivo ha sido eliminado con éxito'
      }) )
    } )
  } 

  const setStatusEndoso = (status,id_cobro,id_endoso) => {
    const { dataEndoso } = state;
    var formData = new FormData();
    formData.append('id_cobro',id_cobro);
    formData.append('status',status)
    setDataDb(formData,'directoryController','setStatusEndosoCobro')
    .then( response => {
      const newData = {...state}
      const { dataEndoso } = newData;
      dataEndoso.lista = dataEndoso.lista.map( element => {
        if(element.id_cobro==id_cobro){
          element.status = status
        }
        return element;
      } )
      setState(newData)
      // console.log
      // setState({ newData })
    })
  }

  const handleCloseModalEditarPagoEndoso = () => setState( prevState => ({ ...prevState, modalEditarPagoEndoso : false }) )
  const handleShowModalEditarPagoEndoso = () => setState( prevState => ({ ...prevState, modalEditarPagoEndoso : true }) )

  const { dataEndoso } = state;

  return(
    <React.Fragment>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        fullscreen={true}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Información del endoso #{endoso}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="ws-modal-body">
          { (isLoading) && (<div className="ws-loader-container"><div className="spinner"></div></div>) }
          <Container>
            <Row>
              <p className="text-secondary">Historial de pagos de endosos a realizar</p>
              {/* PAGOS */}
              <Col xs={12} className="mb-4">
                <div className="ws-box-container">
                  <Table striped responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Mes</th>
                        <th>Pago</th>
                        <th>Estado</th>
                        <th>Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        (typeof dataEndoso.lista!=='undefined' && dataEndoso.lista.length < 1) && (
                          <tr>
                            <td colSpan={5}>
                              <p className="mb-2 mt-2">No hay resultados</p>
                            </td>
                          </tr>
                        )
                      }
                      {
                        (typeof dataEndoso.lista!=='undefined' && dataEndoso.lista.length > 0) && (
                          dataEndoso.lista.map((t,e) => (
                            <tr key={e}>  
                              <td>{t.contador}</td>
                              <td>{t.mes}</td>
                              <td>{number_format(t.endoso)}</td>
                              <td>
                                { (t.status===1) && ( <Badge bg="warning">Sin pagar</Badge> ) }
                                { (t.status===2) && ( <Badge bg="success">Pagado</Badge> ) }
                              </td>
                              <td>
                                <ul className="navbar-nav ms-auto ws-dropdown-list">
                                  <li className="nav-item dropdown position-static">
                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                                      <i className="bi bi-three-dots-vertical"></i>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-start animate slideIn" aria-labelledby="navbarDropdown">
                                      {
                                        (t.status===1) && (
                                          <a className="dropdown-item" href="#"
                                          onClick={ () => { setStatusEndoso(2,t.id_cobro,t.id_endoso) } }
                                          ><i className="bi bi-check-circle-fill pe-2"></i> Marcar pago</a>
                                        )
                                      }
                                      {
                                        (t.status===2) && (
                                          <a className="dropdown-item" href="#"
                                          onClick={ () => { setStatusEndoso(1,t.id_cobro,t.id_endoso) } }
                                          ><i className="bi bi-x-circle-fill pe-2"></i> Quitar pago</a>
                                        )
                                      }
                                      <a className="dropdown-item" href="#"
                                      onClick={ 
                                        () => {
                                          setState( prevState => ({ ...prevState, dataEndosoSelected : t}))
                                          handleShowModalEditarPagoEndoso();
                                        }
                                      }
                                      ><i className="bi bi-pencil-square pe-2"></i> Modificar</a>
                                    </div>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))
                        )
                      }
                    </tbody>
                  </Table>
                </div>
              </Col>  
              {/* NUBE */}
              <Col xs={12} className="mb-4">
                <div className="ws-panel">
                  <div className="ws-panel-header d-flex justify-content-between align-items-center">
                    <h5>Nube</h5>
                    <label className="ws-panel-group-icon" htmlFor="upload-file-cloud">
                      <i className="bi bi-cloud-upload ws-panel-header-icon" htmlFor="upload-file-cloud"></i> 
                      &nbsp;{(state.isUploadButton) ? 'Subiendo...' : 'Subir Archivo'}
                      <input ref={inputFileRef} style={{display:'none'}} id="upload-file-cloud" type="file" onChange={ (file) => handleUploadFile(file) } />
                    </label>
                  </div>
                  <div className="ws-panel-body">
                    <Table striped>
                      <thead>
                          <tr>
                            <th width="10%" style={{textAlign:'center'}}></th>
                            <th width="60%">Archivo</th>
                            <th width="30%">Opciones</th>
                          </tr>
                      </thead>
                      <tbody>
                        {
                          (dataEndoso.nube && dataEndoso.nube.length < 1) && (
                            <tr>
                              <td colSpan={3}>
                                <p className="mb-2 mt-2 text-center">No hay archivos</p>
                              </td>
                            </tr>
                          )
                        }
                        {
                          (dataEndoso.nube && dataEndoso.nube.length > 0 ) && (
                            dataEndoso.nube.map((t,e) => (
                              <tr key={e}>
                                <td>
                                  <i className="bi bi-file-earmark-pdf-fill" style={{fontSize:'4rem',color:'#777'}} ></i>
                                </td>
                                <td>
                                  <Badge bg="danger" className="mb-2">Vigente</Badge>
                                  <p className="mb-2 ws-text-secondary">{t.nombre}</p> 
                                  <p className="mb-2 ws-text-secondary">{t.fecha}</p>
                                </td>
                                <td>
                                  <Button variant="danger" className="me-2" onClick={ () => handleDeletePoliza(t.id_subida) }>
                                    <i className="bi bi-trash"></i> Eliminar
                                  </Button>
                                  <Button className="ws-button-light me-2" onClick={ () => handleDownloadFile(t.id_subida) }>
                                    <i className="bi bi-download"></i> Descargar
                                  </Button>
                                </td>
                              </tr>
                            ))
                          ) 
                        }
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Col>
              {/* OBSERVACIONES */}
              <Col xs={12} className="mb-4">
                <div className="ws-panel">
                  <div className="ws-panel-header d-flex justify-content-between align-items-center">
                    <h5>Observación</h5>
                  </div>
                  <div className="ws-panel-body">
                    <div className="ws-box-pre">
                      {dataEndoso.observacion}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button className="ws-btn-blue-2" onClick={handleClose}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <ModalEditarPagoEndoso 
      show={state.modalEditarPagoEndoso} 
      handleClose={handleCloseModalEditarPagoEndoso} 
      num_endoso={endoso} 
      data={state.dataEndosoSelected} 
      reload={reload} />

    </React.Fragment>
  )
}

const ModalObservacionRecibo = ({ data,show, handleClose }) => {

  const dispatch = useDispatch();
  const [state, setState] = useState({
    observacion_recibo: '',
    errorMessage: '',
    error: false,
    isLoading: false,
  })

  useEffect(() => {
    if(show){
      const formData = new FormData();
      formData.append('id_historial',data.id_historial);
      getDataDb(formData,'mainController','getObservacionFromRecibo')
      .then( response => {
        setState({...state,observacion_recibo: response.res})
      })
    }
  },[show,data])

  const submitForm = () => {
    const formData = new FormData();
    formData.append('id_historial',data.id_historial);
    formData.append('val',state.observacion_recibo);
    setDataDb(formData,'mainController','setObservacionFromRecibo')
    .then( response => {
      console.log(response);
      handleClose();
      setState({ 
        ...state, 
        isLoading: false, 
        error: false,
        observacion_recibo: '',
        errorMessage: '',
      })
      dispatch( showAlert({
        show: true, 
        message : 'Observación agregada correctamente'
      }) )
    })
  }

  const handleSave = () => {
    // if (state.observacion_recibo.trim() === '') {
    //   setState({ ...state, error: true, errorMessage: 'Ingresa una observación del recibo' });
    //   return false;
    // }
    setState({ ...state, error: false,isLoading: true });
    submitForm();
  }

  return(
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Observación de recibo</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">

                <Form className="mb-3">
                  <p>Recibo: #{data.numero}</p>
                  <p>Fecha: {(typeof data.mes!=='undefined') ? data.mes.split(' ')[0] : ''}</p>
                  <Form.Group className="mb-3">
                    <Form.Control 
                    rows="5" 
                    as="textarea" 
                    placeholder="Agrega una observación a este recibo"
                    value={state.observacion_recibo}
                    onChange={ (e) => setState({ ...state, observacion_recibo: e.target.value })}
                    />
                  </Form.Group>
                </Form>

                {
                  (state.error) && (
                    <Alert variant='danger'>
                      <i className='bi bi-exclamation-triangle-fill'></i> {state.errorMessage}
                    </Alert>
                  )
                }

              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button 
        className="ws-btn-blue-2" 
        onClick={ handleSave }
        disabled={ state.isLoading }
        >
          <i className="bi bi-check-circle-fill"></i> { (state.isLoading) ? 'Guardando' : 'Guardar' }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalObservaciones = ({data,show,handleClose}) => {
  const dispatch = useDispatch();
  const refObservaciones = useRef(null);
  const [state,setState] = useState({
    observaciones: '',
    error: false,
    errorMessage: '',
    isLoading: false
  })
  const handleSave = () => {
    setState({...state,isLoading: true});
    const formData = new FormData();
    formData.append('id_poliza',data.id_poliza);
    formData.append('observacion',refObservaciones.current.value);
    setDataDb(formData,'directoryController','wiActualizaObservacionPoliza')
    .then( response => {
      handleClose();
      setState({...state,isLoading: false});
      dispatch( updateContratoObservaciones({
        observacion: refObservaciones.current.value
      }) )
      dispatch( showAlert({
        show: true,
        message: 'Datos guardados correctamente'
      }) )
      console.log(response);
    })
  }
  return(
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Observaciones</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">
                <Form className="mb-3">
                  <Form.Group className="mb-3">
                    <Form.Control 
                    ref={refObservaciones}
                    rows="5" 
                    as="textarea" 
                    placeholder="Agrega una observación a este recibo"
                    defaultValue={data.observacion}
                    />
                  </Form.Group>
                </Form>
                {
                  (state.error) && (
                    <Alert variant='danger'>
                      <i className='bi bi-exclamation-triangle-fill'></i> {state.errorMessage}
                    </Alert>
                  )
                }
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button 
        className="ws-btn-blue-2" 
        onClick={ handleSave }
        disabled={ state.isLoading }
        >
          <i className="bi bi-check-circle-fill"></i> { (state.isLoading) ? 'Guardando' : 'Guardar' }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalModificarRecibo = ({ data,show, handleClose }) => {

  const stateHome = useSelector( (state) => state.agents.home );
  const stateAlert = useSelector( (state) => state.agents.toastAlert );
  const dispatch = useDispatch();
  
  const formEditarRef = useRef(null),
  fechaReciboRef = useRef(null),
  primaNetaRef = useRef(null),
  fechaValue = moment(data.mes_estatic).format('YYYY-MM-DD'),
  primaNetaValue = data.pago,
  idHistorialvalue = data.id_historial;

  const [state, setState] = useState({
    isLoading: false,
    error: false,
    errorMessage: '',
  })  

  const submitForm = (e) => {
    e.preventDefault();
    if(fechaReciboRef.current.value===''){
      setState({ ...state, error: true, errorMessage: 'Ingresa la fecha del recibo'});
      return false;
    }
    if(primaNetaRef.current.value===''){
      setState({ ...state, error: true, errorMessage: 'Ingresa una prima neta' });
      return false;
    }
    setState({ ...state, error: false,isLoading: true});
    const formData = new FormData();
    formData.append('id_historial', idHistorialvalue);
    formData.append('pago', primaNetaRef.current.value);
    formData.append('mes', fechaReciboRef.current.value);
    formData.append('id_contrato',data.id_contrato);
    formData.append('id_usuario',data.id_usuario);
    setDataDb(formData,'directoryController','setModifyRecibo')
    .then( response => {
      console.log(response);
      setState({ 
        ...state, 
        isLoading: false, 
        error: false,
        errorMessage: '',
      })
      handleClose();
      dispatch( updateContrato({
        contratos : response.contratos,
        configuracion : response.configuracion,
      }) )
      dispatch( showAlert({
        show: true,
        message: 'Los datos han sido registrados'
      }) )
    })
  }

  return(
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Modificar recibo</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">
                <Form ref={formEditarRef} onSubmit={ submitForm }>
                  <Form.Group className="mb-3">
                    <Form.Label>Fecha del recibo</Form.Label>
                    <Form.Control 
                    ref={fechaReciboRef}
                    type="date" 
                    defaultValue={fechaValue}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Prima neta</Form.Label>
                    <Form.Control 
                    ref={primaNetaRef}
                    type="text" 
                    defaultValue={primaNetaValue}
                    onChange={ (e) => validateDecimalNumber(e) }
                    />
                  </Form.Group>
                </Form>
                {
                  (state.error) && (
                    <Alert variant='danger'>
                      <i className='bi bi-exclamation-triangle-fill'></i> {state.errorMessage}
                    </Alert>
                  )
                }
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button className="ws-btn-blue-2" onClick={ () => formEditarRef.current.requestSubmit() } disabled={ state.isLoading } >
          <i className="bi bi-check-circle-fill"></i> {state.isLoading ? 'Guardando' : 'Guardar' } 
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalFechaPago = ({ data,show, handleClose }) => {

  const dispatch = useDispatch();

  const [state, setState] = useState({
    fecha_pago : '',
    isLoading: false,
    error: false,
    errorMessage: '',
  })

  useEffect(() => {
    if(show){
      const formData = new FormData();
      formData.append('id_historial',data);
      getDataDb(formData,'mainController','wiGetFechaPagoCotejado')
      .then( response => {
        setState({...state,fecha_pago: response.res})
      })
    }
  },[show,data])

  const quitarFechaPagoCotejado = () => {
    const formData = new FormData();
    formData.append('id_historial',data);
    formData.append('val','0000-00-00');
    setDataDb(formData,'mainController','wiSetFechaPagoCotejado')
    .then( response => {
      console.log(response);
      handleClose();
      setState({ 
        ...state, 
        isLoading: false, 
        error: false,
        errorMessage: '',
        fecha_pago: '',
      })
      dispatch( showAlert({
        show: true,
        message: 'Datos guardados correctamente'
      }) )
    })
  }

  const submitForm = () => {
    const formData = new FormData();
    formData.append('id_historial',data);
    formData.append('val',state.fecha_pago);
    setDataDb(formData,'mainController','wiSetFechaPagoCotejado')
    .then( response => {
      console.log(response);
      handleClose();
      setState({ 
        ...state, 
        isLoading: false, 
        error: false,
        errorMessage: '',
        fecha_pago: '',
      })
      dispatch( showAlert({
        show: true, 
        message: 'Los datos han sido registrados'
      }))      
    })
  }

  const handleSave = (type) => {
    if(state.fecha_pago === ''){
      setState({ ...state, error: true, errorMessage: 'Ingresa la fecha del pago'});
      return false;
    }
    setState({ ...state, error: false,isLoading: true });
    if(type===1) quitarFechaPagoCotejado();
    if(type===2) submitForm();
  }

  return(
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Guardar fecha de pago realizado</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">
                <Form className="mb-3">
                  <p className="text-secondary">Puedes guardar una fecha de pago adicional a la asignada en los pagos subsecuentes</p>
                  <Form.Group className="mb-3">
                    <Form.Label>Fecha (requerido)</Form.Label>
                    <Form.Control 
                    type="date" 
                    value={state.fecha_pago}
                    onChange={ (e) => setState({ ...state, fecha_pago: e.target.value }) } />
                  </Form.Group>
                </Form>
                {
                  (state.error) && (
                    <Alert variant='danger'>
                      <i className='bi bi-exclamation-triangle-fill'></i> {state.errorMessage}
                    </Alert>
                  )
                }
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger"
        onClick={ () => handleSave(1) }
        disabled={ state.isLoading }
        >
          <i className="bi bi-x-circle"></i> Quitar pago
        </Button>
        <Button 
        className="ws-btn-blue-2" 
        onClick={ () => handleSave(2) }
        disabled={ state.isLoading }
        >
          <i className="bi bi-check-circle-fill"></i> { (state.isLoading) ? 'Guardando...' : 'Guardar' }
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const ModalEditarFicha = ({data,show,handleClose}) => {

  const dispatch = useDispatch();
  const fi = data.fecha_inicio.replace( /\s\s+/g, ' ');
  const horaInicio = fi.split(' ')[1]
	const fechaInicioSplit = fi.split(' ')[0]
	const fechaInicioR = fechaInicioSplit.split('/')
	const fecha_inicio = fechaInicioR[2]+'-'+fechaInicioR[1]+'-'+fechaInicioR[0]+'T'+ horaInicio

  const ff = data.fecha_fin.replace( /\s\s+/g, ' ');
  const horaFin = ff.split(' ')[1]
	const fechaFinSplit = ff.split(' ')[0]
	const fechaFinR = fechaFinSplit.split('/')
	const fecha_fin = fechaFinR[2]+'-'+fechaFinR[1]+'-'+fechaFinR[0]+'T'+ horaFin

  const refFechaInicio = useRef(null),
  refFechaFin = useRef(null),
  refFormaPago = useRef(null),
  refRamo = useRef(null);

  const [state,setState] = useState({
    error: false,
    errorMessage: '',
    isLoading: false
  })

  const handleSave = () => {

    if(refFechaInicio.current.value == ''){
      setState({...state, error: true, errorMessage: 'Agrega una fecha de inicio'})
      return false;
    }
    if(refFechaFin.current.value == ''){
      setState({...state, error: true, errorMessage: 'Agrega una fecha de vencimiento'})
      return false;
    }
    if(refFormaPago.current.value == ''){
      setState({...state, error: true, errorMessage: 'Selecciona una forma de pago'})
      return false;
    }
    if(refRamo.current.value == ''){
      setState({...state, error: true, errorMessage: 'Selecciona un ramo'})
      return false;
    }
    
    setState({...state,error:false,errorMessage:'',isLoading:true});
    const formData = new FormData();
    formData.append('inicia',refFechaInicio.current.value);
    formData.append('vence',refFechaFin.current.value);
    formData.append('f_pago',refFormaPago.current.value);
    formData.append('id_contrato',data.id_contrato);
    formData.append('id_usuario',data.id_usuario);
    formData.append('ramo',refRamo.current.value);
    setDataDb(formData,'directoryController','setFichaContrato')
    .then( response=> {
      handleClose();
      setState({...state, isLoading: false})
      dispatch( showAlert({
        show: true,
        message: 'Datos guardados correctamente'
      }) )
      dispatch( updateContrato({
        configuracion: response.configuracion
      }))
    })
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Editar ficha</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">
                <Form className="mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Inicia (requerido)</Form.Label>
                    <Form.Control ref={refFechaInicio} type="datetime-local" defaultValue={fecha_inicio} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Vence (requerido)</Form.Label>
                    <Form.Control ref={refFechaFin} type="datetime-local" defaultValue={fecha_fin} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Concepto de pago (requerido)</Form.Label>
                    <Form.Select ref={refFormaPago} defaultValue={data.forma_pago}>
                      <option value="0" disabled>Elige una opción</option>
                      <option value="c">Cargo a tarjeta</option>
                      <option value="e">Efectivo</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Ramo (requerido)</Form.Label>
                    <Form.Select ref={refRamo} defaultValue={data.ramo}>
                      <option value="io_contrato_autos">AUTOMÓVILES</option>
                      <option value="io_contrato_gmm">GASTOS MÉDICOS MAYORES</option>
                      <option value="io_contrato_vida">VIDA</option>
                      <option value="io_contrato_fianzas">FIANZAS</option>
                      <option value="io_contrato_negocio">NEGOCIOS ESPECIALES</option>
                    </Form.Select>
                  </Form.Group>
                </Form>
                {
                  (state.error) && (
                    <Alert variant='danger'>
                      <i className='bi bi-exclamation-triangle-fill'></i> {state.errorMessage}
                    </Alert>
                  )
                }
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button 
        className="ws-btn-blue-2" 
        onClick={ handleSave }
        disabled={ state.isLoading }
        >
          <i className="bi bi-check-circle-fill"></i> { (state.isLoading) ? 'Guardando...' : 'Guardar' }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalAgentesCompartidos = ({data,show,handleClose}) => {
  const [state,setState] = useState({
    error: false,
    errorMessage:'',
    isLoading: false
  })
  const handleSave = () => {
    console.log('Guardando datos...');
  }
  const getUsuariosAgente = () => {
    const formData = new FormData();
    formData.append('id_poliza',data);
    getDataDb(formData,'directoryController','wiObtenUsuariosAgente')
    .then( response => {
      console.log(response);
    })
  } 
  useEffect(() => {
    if(show){
      getUsuariosAgente();
    }
  },[show])
  return(
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Agentes compartidos</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">
                <p>Agentes compartidos</p>
                {
                  (state.error) && (
                    <Alert variant='danger'>
                      <i className='bi bi-exclamation-triangle-fill'></i> {state.errorMessage}
                    </Alert>
                  )
                }
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button 
        className="ws-btn-blue-2" 
        onClick={ handleSave }
        disabled={ state.isLoading }
        >
          <i className="bi bi-check-circle-fill"></i> { (state.isLoading) ? 'Guardando...' : 'Guardar' }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalRecibos = ({ show, handleClose,getViewContrato,homeSection }) => {
  //REF
  const inputFileRef = useRef(null);
  //Estado Global
  const initData = useSelector( (state) => state.agents.initData );
  const stateHome = useSelector( (state) => state.agents.home );
  const { section,arrContrato, isLoadingViewContrato,modalRecibo } = stateHome;
  const { sectionRecibo,modalEditarPrimas } = modalRecibo;
  const { companies, ramos} = initData;
  const dispatch = useDispatch();

  console.log('arr_contrato',arrContrato)

  let numeroPoliza = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.numero_poliza : '';
  let idPoliza = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.id_poliza : '';
  let nombreCompania = (typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.compania : '';
  let arrFrom;
  if(section===1) arrFrom = 'arrPorPagar'
  if(section===2) arrFrom = 'arrPagados'
  if(section===3) arrFrom = 'arrVencidos'
  if(section===4) arrFrom = 'arrRenovaciones'
  let dataRecibo = stateHome[arrFrom].filter( element => element.numero_poliza == numeroPoliza);
  let idContrato = dataRecibo[0]?.id_contrato;
  let idUsuario = dataRecibo[0]?.id_usuario;

  const [state, setState] = useState({
    modalEndoso: false,
    modalObservacion: false,
    modalObservaciones: false,
    modalModificarRecibo: false,
    modalFechaPago: false,
    modalVerEndoso: false,
    modalMarcarPago: false,
    modalEditarFicha: false,
    modalAgentesCompartidos: false,
    isLoadingVerEndoso: false,
    dataPanel: [],
    isLoadPanel: false,
    numero_endoso: '',
    id_endoso: '',
    isLoadingConfirmacion: false,
    dataEndoso: [],
    dataRecibo: [],
    dataFicha: {
      fecha_inicio: '',
      fecha_fin: '',
      forma_pago: '',
      ramo: '',
      id_contrato : '',
      id_usuario: ''
    },
    dataObservacion: [],
    btnLoadingFile : false,
    id_historial : '', 
    editarExtra: false,
    isLoadingExtra: false,
  });

  const [dataFile, setDataFile] = useState({
    id_subida : '',
    nombre : '',
    isLoadingButton: false,
    modalDeleteFile: false,
  });

  const [dataExtraObj,setDataExtraObj] = useState([{}]);
  useEffect( () => {
    if(typeof arrContrato.extra !== 'undefined'){
      if(arrContrato.extra.length>0){
        let newObj = arrContrato.extra.map( element => {
          return {
            'id_dato' : "null",
            'id_padre' : element.id_padre,
            'valor' : element.nombre
          }
        })
        setDataExtraObj(newObj);
      }
    }
  },[arrContrato])

  const [modalConfirmacion,setModalConfirmacion] = useState(false);
  const handleShowModalConfirmacion = () => setModalConfirmacion(true);
  const handleCloseModalConfirmacion = () => setModalConfirmacion(false);

  const handleCloseModalEditPrimas = () => dispatch( setStateHomeRecibo( { modalEditarPrimas : false } ) );
  const handleShowModalEditPrimas = () => dispatch( setStateHomeRecibo( { modalEditarPrimas : true } ) );
  const handleCloseModalEditarFicha = () => setState({...state, modalEditarFicha: false});
  const handleShowModalEditarFicha = (t) => setState({...state, modalEditarFicha: true, dataFicha: t}); 

  const handleCloseModalAgentesCompartidos = () => setState({...state,modalAgentesCompartidos: false});
  const handleShowModalAgentesCompartidos = () => setState({...state,modalAgentesCompartidos: true});

  const handleCloseModalEndoso = () => setState({ ...state, modalEndoso: false });
  const handleShowModalEndoso = () => setState({ ...state, modalEndoso: true });
  const handleShowModalObservacion = (t) => setState({ ...state, modalObservacion: true, dataRecibo: t });
  const handleCloseModalObservacion = () => setState({ ...state, modalObservacion: false });
  const handleShowModalObservaciones = (t) => setState({...state, modalObservaciones: true, dataObservacion: t});
  const handleCloseModalObservaciones = () => setState({ ...state, modalObservaciones: false });
  const handleShowModalModificarRecibo = (t) => {
    setState({ ...state, modalModificarRecibo: true, dataRecibo: t });
  }
  const handleCloseModalModificarRecibo = () => setState({ ...state, modalModificarRecibo: false });
  const handleShowModalFechaPago = (t) => setState({ ...state, modalFechaPago: true, id_historial : t });
  const handleCloseModalFechaPago = () => setState({ ...state, modalFechaPago: false });
  const handleCloseModalMarcarPago = () => setState({ ...state, modalMarcarPago: false });
  const handleShowModalMarcarPago = (t) => setState({ ...state, modalMarcarPago: true, id_historial: t });

  const getListEndoso = (numero_endoso,id_endoso) => {
    var formData = new FormData();
    formData.append('id_endoso',id_endoso);
    getDataDb(formData,'directoryController','getListEndoso')
    .then( response => {
      setState({ ...state, modalVerEndoso: true, dataEndoso: response, isLoadingVerEndoso:false, numero_endoso, id_endoso })
    });
  }

  const handleShowModalVerEndoso = (numero_endoso,id_endoso) => {
    setState({ ...state, modalVerEndoso: true, isLoadingVerEndoso:true, numero_endoso, id_endoso})
    getListEndoso(numero_endoso,id_endoso);
  };

  const handleCloseModalVerEndoso = () =>  setState({ ...state, modalVerEndoso: false});

  const setSection = (sectionRecibo) => dispatch( setStateHomeRecibo({ sectionRecibo }) )

  const goToDownloadPoliza = (id_subida,ruta) =>{
    var formData = new FormData();
    formData.append('id_subida', id_subida)
    fetch('REST/controllers/cloudController?opt=goToDownloadPoliza',{
      method: 'POST',
      mode: 'cors',
      body: formData
    })
    .then( response => response.json() )
    .then( response => {
      const linkDownload = response;
      window.open(linkDownload,'_blank').focus();
      // console.log(response)
    })
  }

  const goToDeletePoliza = (id_subida) =>{
    setDataFile({...state,isLoadingButton: true});
    var formData = new FormData();
    formData.append('id_subida', id_subida);
    setDataDb(formData,'cloudController','goToDeletePoliza')
    .then( response => {
      dispatch( updateContrato({
        nube: response.nube 
      }) )
      dispatch( showAlert({
        show: true,
        message: 'Se ha eliminado el archivo con éxito'
      }) )
      setDataFile({...state,modalDeleteFile: false})
    })
  }

  const deleteEndoso = () => {
    setState({ ...state, isLoadingConfirmacion: true });
    var formData = new FormData();
    formData.append('id_endoso',state.id_endoso);
    formData.append('id_usuario',dataRecibo[0].id_usuario);
    formData.append('id_contrato',dataRecibo[0].id_contrato);
    deleteDataDb(formData,'directoryController','setDeleteEndosoGeneral')
    .then( response => {
      setState({ ...state, isLoadingConfirmacion: false });

      dispatch( showAlert( { 
        show : true, 
        message : 'Endoso removido con éxito'
      } ) );

      dispatch( actualizarEndoso({
        configuracion: response.configuracion,
        contratos: response.contratos,
        endosos: response.endosos
      }) );
      
      // console.log(response)
      // toast.success( (e) => (
      //   <p className="mb-0">Endoso removido con éxito.</p>
      // ),{
      //   duration: 2000
      // });
      handleCloseModalConfirmacion();
    })
  }

  const setStatusEndoso = (id_historial,status,id_cobro) => {

    var formData = new FormData();
    formData.append('id_cobro',id_cobro);
    formData.append('service','active');
    formData.append('status',status)

    setDataDb(formData,'directoryController','setStatusEndosoCobro')
    .then( response => {

      dispatch( updateStatusEndoso( {
        id_historial,
        status,
        id_cobro
      } ) )

      let message = (status===1) ? 'Haz quitado este pago con éxito.' : 'Haz marcado este recibo como pagado.';

      toast.success( (e) => (
        <p className="mb-0">{message}</p>
      ),{
        duration: 2000
      });
      
    })
  }

  const uploadFileToCloud = (file) => {
    setState({ ...state, btnLoadingFile: true });
    console.log('Archivo:',file.target.files[0]);
    const formData = new FormData();
    formData.append('image', file.target.files[0]);
    setDataDb(formData,'cloudController',`archivoPoliza&id_poliza=${idPoliza}`)
    .then( response => {
      inputFileRef.current.value = "";
      setState({ ...state, btnLoadingFile: false });
      dispatch( updateContrato({
        configuracion: response.configuracion,
        nube: response.nube
      }))
      dispatch( showAlert({
        show: true,
        message: 'Tu archivo se ha subido con éxito'
      }) )
    })
  }

  const quitarPagoRecibo = (id_historial) => {
    const formData = new FormData();
    formData.append('id_historial',id_historial);
    setDataDb(formData,'mainController','quitarPago')
    .then( response => {
      dispatch( updateStatusRecibo({
        id_historial,
        status : 0
      }) )
      dispatch( showAlert({
        show: true,
        message: 'Has quitado este pago con éxito'
      }) )
    })
  }

  const saveExtras = () => {
    setState({...state,isLoadingExtra:true});
    let objExtra = JSON.stringify(dataExtraObj);
    const formData = new FormData();
    formData.append('id_poliza',idPoliza);
    formData.append('adicional',objExtra);
    setDataDb(formData,'directoryController','wiActualizaAdicionalPoliza')
    .then( response => {
      setState({...state,isLoadingExtra:false, editarExtra: false});
      dispatch( showAlert({
        show: true,
        message: 'Datos guardados correctamente'
      }) )
    } )
  }

  let prima_total = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.prima_total : 0,
  prima_neta = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.prima_neta : 0,
  abonado = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.abonado : 0,
  moneda = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.moneda : '-',
  numero_poliza = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.numero_poliza : '',
  nombre_cliente = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.nombre_cliente : '',
  telefono_cliente = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.telefono_cliente : '',
  celular_cliente = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.celular_cliente : '',
  email_cliente = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.email_cliente : '',
  fecha_inicio = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.fecha_inicio : '',
  fecha_fin = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.fecha_fin : '',
  numero_renovacion = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.numero_renovacion : '',
  company = ( typeof arrContrato.configuracion !== 'undefined') ? companies.filter( company => company.id_compania == arrContrato.configuracion.id_compania)[0].nombre : '',
  ramo = ( typeof arrContrato.configuracion !== 'undefined') ? ramos.filter( ramo => ramo.id_padre == arrContrato.configuracion.id_ramo)[0].nombre : '',
  nombre_creador = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.nombre_creador : '',
  fecha = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.fecha : '',
  nube = ( typeof arrContrato.nube !== 'undefined') ? arrContrato.nube : [],
  extra = ( typeof arrContrato.extra !== 'undefined') ? arrContrato.extra : [],
  endosos = ( typeof arrContrato.endosos !== 'undefined') ? arrContrato.endosos : [],
  contratos = ( typeof arrContrato.contratos !== 'undefined') ? arrContrato.contratos : [],
  observacion = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.observacion : '',
  forma_pago = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.forma_pago : '',
  id_ramo = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.id_ramo : '' ;

  return (
    <React.Fragment>
      <Modal show={show} onHide={handleClose} size="lg" fullscreen={true}>
        <Modal.Header closeButton className='ws-modal-header'>
          <Modal.Title>Póliza #{numero_poliza}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="ws-modal-body" style={{position:'relative',overflowY: (isLoadingViewContrato) ? 'hidden' : 'scroll'}}>
          { (isLoadingViewContrato) && (<div className="ws-loader-container"><div className="spinner"></div></div>) }
          <Container>
            <Row>

              <Col xs={12}>
                <div className="ws-tab-container pb-2 mt-3">
                  <ul className="nav nav-pills mb-3">
                    <li className="nav-item">
                      <a className={`nav-link ${(sectionRecibo === 1) && 'active' }`} aria-current="page" href="#" onClick={ () => setSection(1) }>Detalles</a>
                    </li>
                    <li className="nav-item ms-2">
                      <a className={`nav-link ${(sectionRecibo === 2) && 'active' }`} aria-current="page" href="#" onClick={ () => setSection(2) }>Recibos</a>
                    </li>
                  </ul>
                  <hr />
                </div>
              </Col>

              {
                (sectionRecibo === 2) && (
                  <React.Fragment>
                    {/* PRIMAS */}
                    <Col xs={12} className="mb-4">
                      <div className="ws-panel">
                        <div className="ws-panel-header d-flex justify-content-between align-items-center">
                          <h5>Primas</h5>
                          <i className="bi bi-pencil-square ws-panel-header-icon" onClick={handleShowModalEditPrimas}></i>
                        </div>
                        <div className="ws-panel-body">
                          <Row>
                            <Col xs={12} md={4}>
                              <div className="ws-widget">
                                <h5>Prima total</h5>
                                <p className='ws-widget-total'>${prima_total} <span className="ws-type-currency">{moneda}</span></p>
                              </div>
                            </Col>
                            <Col xs={12} md={4}>
                              <div className="ws-widget">
                                <h5>Prima Neta</h5>
                                <p className='ws-widget-total'>${prima_neta} <span className="ws-type-currency">{moneda}</span></p>
                              </div>
                            </Col>
                            <Col xs={12} md={4}>
                              <div className="ws-widget">
                                <h5>Prima Abonada</h5>
                                <p className='ws-widget-total'>${abonado} <span className="ws-type-currency">{moneda}</span></p>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                    {/* ENDOSOS */}
                    <Col xs={12} className="mb-4">
                      <div className="ws-panel">
                        <div className="ws-panel-header d-flex justify-content-between align-items-center">
                          <h5>Endosos</h5>
                          <Button onClick={handleShowModalEndoso} className="ws-btn-blue-2">
                            <i className="bi bi-plus"></i>&nbsp;Nuevo endoso
                          </Button>
                        </div>
                        <div className="ws-panel-body">
                          <Table>
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Fecha inicial</th>
                                <th>Recibo</th>
                                <th>Recibo inicial</th>
                                <th>Opciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                (endosos && endosos.length < 1) && (
                                  <tr>  
                                    <td colSpan={5} className="align-self-center text-center">
                                      <p className="mb-2 mt-2">No hay resultados</p>
                                    </td>
                                  </tr>
                                )
                              }
                              {
                                (endosos && endosos.length > 0) && (
                                  endosos.map((t,e) => ( 
                                    <tr key={e}>
                                      <td>{t.numero_endoso}</td>
                                      <td>{t.fecha}</td>
                                      <td>${t.total}</td>
                                      <td>{t.recibo_inicial}</td>
                                      <td>
                                        <ul className="navbar-nav ms-auto ws-dropdown-list">
                                          <li className="nav-item dropdown position-static">
                                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </a>
                                            <div className="dropdown-menu dropdown-menu-start animate slideIn" aria-labelledby="navbarDropdown">
                                              <a className="dropdown-item" href="#" 
                                              onClick={ () =>{
                                                handleShowModalVerEndoso(t.numero_endoso,t.id_endoso);
                                              } }><i className="bi bi-file-text-fill pe-2"></i> Visualizar</a>
                                              <a className="dropdown-item" href="#" 
                                              onClick={ () => {
                                                setState({ ...state, numero_endoso: t.numero_endoso, id_endoso: t.id_endoso})
                                                handleShowModalConfirmacion();
                                              }  }><i className="bi bi-trash pe-2"></i> Eliminar</a>
                                            </div>
                                          </li>
                                        </ul>
                                      </td>
                                    </tr>
                                  ))
                                )
                              }
                              
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Col>
                    {/* RECIBOS */}
                    <Col xs={12}>
                      <div className="ws-panel">
                        <div className="ws-panel-header d-flex justify-content-between align-items-center">
                          <h5>Recibos</h5>
                        </div>
                        <div className="ws-panel-body">
                          <Table>
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Mes</th>
                                <th>Prima</th>
                                <th>Abonado</th>
                                <th>Estado</th>
                                <th>Opciones</th>
                              </tr>
                            </thead>
                            <tbody>

                              {
                                (contratos && contratos.length < 1) && (
                                  <tr>  
                                    <td colSpan={6} className="align-self-center text-center">
                                      <p className="mb-2 mt-2">No hay resultados</p>
                                    </td>
                                  </tr>
                                )
                              }

                              {
                                (contratos && contratos.length > 0) && (
                                  contratos.map((t,e) => {
                                    let estado;
                                    let bgBadge;

                                    if(t.estado===1) estado = 'Pagado'
                                    if(t.estado===0) estado = 'Sin Pagar'
                                    
                                    if(t.estado===1) bgBadge = 'success'
                                    if(t.estado===0) bgBadge = 'danger'

                                    return(
                                      <React.Fragment key={e}>
                                        <tr>
                                          <td>{t.numero}</td>
                                          <td>{t.mes}</td>
                                          <td>
                                            <span className="ws-type-currency">{moneda}</span>&nbsp;${t.pago}
                                          </td>
                                          <td>
                                            <span className="ws-type-currency">{moneda}</span>&nbsp;${t.pago}
                                          </td>
                                          <td>
                                            <span className={`badge bg-${bgBadge}`}>{estado}</span>
                                          </td>
                                          <td>
                                            <ul className="navbar-nav ms-auto ws-dropdown-list" title="Ver opciones">
                                              <li className="nav-item dropdown position-static">
                                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                                                  <i className="bi bi-three-dots-vertical"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">

                                                  {
                                                    (t.estado===1) && (
                                                      <a className="dropdown-item" href="#"
                                                      onClick={ () => quitarPagoRecibo(t.id_historial) }
                                                      ><i className="bi bi-check-circle-fill pe-2"></i> Quitar Pago</a>
                                                    )
                                                  }

                                                  {
                                                    (t.estado===0) && (
                                                      <a className="dropdown-item" href="#"
                                                      onClick={ () => handleShowModalMarcarPago(t.id_historial) }
                                                      ><i className="bi bi-check-circle-fill pe-2"></i> Marcar Pago</a>
                                                    )
                                                  }
                                                  
                                                  <a className="dropdown-item" href="#" onClick={ () => handleShowModalModificarRecibo(t) }>
                                                    <i className="bi bi-exclamation-triangle-fill pe-2"></i> Modificar
                                                  </a>
                                                  <a className="dropdown-item" href="#" 
                                                  onClick={ 
                                                    () => {
                                                      handleShowModalFechaPago(t.id_historial);
                                                    }
                                                  }><i className="bi bi-file-text-fill pe-2"></i> Fecha de pago</a>
                                                  <a className="dropdown-item" href="#" 
                                                  onClick={ () => handleShowModalObservacion(t) }>
                                                    <i className="bi bi-x-circle-fill pe-2"></i> Observación
                                                  </a>
                                                </div>
                                              </li>
                                            </ul>
                                          </td>
                                        </tr>
                                        {
                                          (typeof t.endosos !== 'undefined' && t.endosos.length > 0) && (
                                            (t.endosos).map((endoso,index) => {
                                              let estado;
                                              let bgBadge;

                                              if(endoso.status===2) estado = 'Pagado'
                                              if(endoso.status===1) estado = 'Pendiente'  
                                              if(endoso.status===2) bgBadge = 'success'
                                              if(endoso.status===1) bgBadge = 'warning'

                                              return(
                                                <tr style={{backgroundColor:'#e0f8ff'}}>  
                                                  <td>.{index+1}</td>
                                                  <td>-</td>
                                                  <td>${endoso.monto}</td>
                                                  <td>-</td>
                                                  <td>  
                                                    <span className={`badge bg-${bgBadge}`}>{estado}</span>
                                                  </td>
                                                  <td>
                                                   <i 
                                                   className={`bi  ${(endoso.status===2) ? 'bi-x' : 'bi-check' }`}
                                                   style={{ fontSize:'25px',cursor:'pointer'}}
                                                   title={(endoso.status===2) ? 'Quitar pago' : 'Marcar pago'}
                                                   onClick = {
                                                    () => {
                                                      let status = (endoso.status===2) ? 1 : 2;
                                                      setStatusEndoso(t.id_historial,status,endoso.id_cobro);
                                                    }
                                                   }
                                                   ></i>   
                                                  </td>
                                                </tr>
                                              )
                                            })
                                          )
                                        }
                                        {
                                          (typeof t.endosos !== 'undefined' && t.endosos.length > 0) && (
                                            <tr style={{backgroundColor:'#e0f8ff'}}> 
                                              <td></td> 
                                              <td></td> 
                                              <td style={{color:'red',fontWeight:'600'}}>
                                                <span className="ws-type-currency">{moneda}</span>&nbsp;${number_format(t.total_recibo)}
                                              </td> 
                                              <td></td> 
                                              <td></td> 
                                              <td></td> 
                                            </tr>
                                          )
                                        }
                                      </React.Fragment>
                                    )
                                  })
                                )
                              }
                              
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Col>
                  </React.Fragment>
                )
              } 

              {/* DETALLES */}
              {
                (sectionRecibo===1) && (
                  <React.Fragment>
                    {/* FICHA */}
                    <Col xs={12} className="mb-4">
                      <div className="ws-panel">
                        <div className="ws-panel-header d-flex justify-content-between align-items-center">
                          <h5>Ficha</h5>
                          <i className="bi bi-pencil-square ws-panel-header-icon" 
                          onClick={
                            () => handleShowModalEditarFicha({
                              fecha_inicio,
                              fecha_fin,
                              forma_pago,
                              ramo : id_ramo,
                              id_contrato : idContrato,
                              id_usuario: idUsuario
                            })
                          }></i>
                        </div>
                        <div className="ws-panel-body">
                          <Table striped>
                            <tbody>
                              <tr>
                                <td width="15%">cliente</td>
                                <td><b>{nombre_cliente}</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Teléfono</td>
                                <td><b>{telefono_cliente}</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Celular</td>
                                <td><b>{celular_cliente}</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Correo electrónico</td>
                                <td><b>{email_cliente}</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Estado</td>
                                <td><b>Vigente</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Inicia</td>
                                <td><b>{fecha_inicio}</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Vence</td>
                                <td><b>{fecha_fin}</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Forma de pago</td>
                                <td><b>{numero_renovacion}</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Concepto de pago</td>
                                <td><b>Cargo a tarjeta</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Moneda</td>
                                <td><b>Peso mexicano</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Compañía</td>
                                <td><b>{company}</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Ramo</td>
                                <td><b>{ramo}</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Creador</td>
                                <td><b>{nombre_creador}</b></td>
                              </tr>
                              <tr>
                                <td width="15%">Fecha</td>
                                <td><b>{fecha}</b></td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Col>
                    {/* EXTRA */}
                    <Col xs={12} className="mb-4">
                      <div className="ws-panel">
                        <div className="ws-panel-header d-flex justify-content-between align-items-center">
                          <h5>Extra</h5>
                          {
                            (state.editarExtra) ?
                            <button className="btn btn-primary ws-btn-blue-2"
                            onClick={ () =>{
                              saveExtras();
                            } }
                            disabled={state.isLoadingExtra}
                            >  
                            <i className="bi bi-check-circle-fill"></i>&nbsp;{(state.isLoadingExtra) ? 'Guardando...' : 'Guardar'}
                            </button>
                            :
                            <i className="bi bi-pencil-square ws-panel-header-icon" 
                            onClick={
                              () => setState({...state,editarExtra:true})
                            }
                            ></i>
                          }
                          
                        </div>
                        <div className="ws-panel-body">
                          {
                            (extra && extra.length < 1) && (
                              <p className="mb-0">No hay datos que mostrar</p>
                            )
                          }
                          {
                            (extra && extra.length > 0) && (
                              extra.map((t,e) => (
                                <div className="ws-box-container-list" key={e}>
                                  <h4>{t.padre}</h4>
                                  {
                                    state.editarExtra ?
                                    <Form.Control 
                                    name={t.id_padre}
                                    value={dataExtraObj.filter( element => element.id_padre === t.id_padre)[0].valor}
                                    onChange={ (e) => {
                                      const { name, value } = e.target;
                                      const newState = [...dataExtraObj]
                                      newState.map((item,index) => {  
                                        if(item.id_padre===t.id_padre){
                                          item.valor = value
                                        }
                                      });
                                      setDataExtraObj(newState)
                                    }}
                                    />
                                    : <p>{dataExtraObj.filter( element => element.id_padre === t.id_padre)[0].valor}</p>
                                  }
                                </div>
                              ))
                            )
                          }
                          
                        </div>
                      </div>
                    </Col>
                    {/* NUBE */}
                    <Col xs={12} className="mb-4">
                      <div className="ws-panel">
                        <div className="ws-panel-header d-flex justify-content-between align-items-center">
                          <h5>Nube</h5>
                          <label className="ws-panel-group-icon" htmlFor="upload-file-cloud">
                            <i className="bi bi-cloud-upload ws-panel-header-icon" htmlFor="upload-file-cloud"></i> 
                            &nbsp;{(state.btnLoadingFile) ? 'Subiendo...' : 'Subir Archivo'}
                            <input ref={inputFileRef} style={{display:'none'}} id="upload-file-cloud" type="file" onChange={ (file) => uploadFileToCloud(file) } />
                          </label>
                        </div>
                        <div className="ws-panel-body">
                          <Table striped>
                            <thead>
                                <tr>
                                  <th width="10%" style={{textAlign:'center'}}></th>
                                  <th width="60%">Archivo</th>
                                  <th width="30%">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                              {
                                (nube.length < 1) && (
                                  <tr>
                                    <td colSpan={3}>
                                      <p className="mb-2 mt-2">No hay archivos</p>
                                    </td>
                                  </tr>
                                )
                              }
                              {
                                (nube && nube.length > 0 ) && (
                                  nube.map((t,e) =>(
                                    <tr key={e}>
                                      <td>
                                        <i className="bi bi-file-earmark-pdf-fill" style={{fontSize:'4rem',color:'#777'}} ></i>
                                      </td>
                                      <td>
                                        <Badge bg="danger" className="mb-2">{ (t.status) ? 'Vigente' : 'Cancelación'}</Badge>
                                        <p className="mb-2 ws-text-secondary">{t.nombre}</p> 
                                        <p className="mb-2 ws-text-secondary">{t.fecha}</p>
                                      </td>
                                      <td>
                                        <Button variant="danger" className="me-2" 
                                        onClick={ () => {
                                          setDataFile({
                                            ...state,
                                            id_subida: t.id_subida,
                                            nombre: t.nombre,
                                            modalDeleteFile: true,
                                          })
                                        } }>
                                          <i className="bi bi-trash"></i> Eliminar
                                        </Button>
                                        <Button className="ws-button-light me-2" onClick={ () => goToDownloadPoliza(t.id_subida,t.ruta) }>
                                          <i className="bi bi-download"></i> Descargar
                                        </Button>
                                      </td>
                                    </tr>
                                  ))
                                ) 
                              }
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Col>
                    {/* OBSERVACIONES */}
                    <Col xs={12} className="mb-4">
                      <div className="ws-panel">
                        <div className="ws-panel-header d-flex justify-content-between align-items-center">
                          <h5>Observaciones</h5>
                          <div className="ws-panel-group-icon">
                            <i className="bi bi-pencil-square ws-panel-header-icon" 
                            onClick={
                              () => handleShowModalObservaciones({
                                observacion,
                                id_poliza: idPoliza
                              })
                            }></i>
                          </div>
                        </div>
                        <div className="ws-panel-body">
                          <div className="ws-box-pre">
                          {
                            observacion
                          }
                          </div>
                        </div>
                      </div>
                    </Col>
                    {/* AGENTES COMPARTIDOS */}
                    <Col xs={12} className="mb-4">
                      <div className="ws-panel">
                        <div className="ws-panel-header d-flex justify-content-between align-items-center">
                          <h5>Agentes Compartidos</h5>
                          <div className="ws-panel-group-icon"
                          onClick={handleShowModalAgentesCompartidos}
                          >
                            <i className="bi bi-person-plus-fill ws-panel-header-icon"></i> 
                            &nbsp;Agregar agente
                          </div>
                        </div>
                        <div className="ws-panel-body">
                          <Table striped responsive>
                            <tbody>
                              <tr>
                                <td>
                                  <Form.Group controlId="frmAgenteC1">
                                    <Form.Check type="checkbox" label="JOSE ANTONIO RAMIRO (71266)" style={{ cursor: 'pointer'}} />
                                  </Form.Group>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <Form.Group controlId="frmAgenteC2">
                                    <Form.Check type="checkbox" label="ANCELMO RUBIO REYES (60650)" />
                                  </Form.Group>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <Form.Group controlId="frmAgenteC3">
                                    <Form.Check type="checkbox" label="SANDRO RAMIREZ VALADEZ (623424)" />
                                  </Form.Group>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Col>
                  </React.Fragment>
                )
              }

            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary ws-btn-blue-2" onClick={handleClose}>Cerrar</button>
        </Modal.Footer>
      </Modal>
      
      {/* MODAL CONFIRMAR PAGO */}
      {/* <ModalMarcarPago
      show={state.modalMarcarPago} 
      handleClose={handleCloseModalMarcarPago} 
      dataPoliza={dataRecibo}
      company={nombreCompania}
      section={homeSection}
      /> */}
      <ModalMarcarPagoRecibo 
      show={state.modalMarcarPago}
      handleClose={handleCloseModalMarcarPago}
      data={state.id_historial}
      />

      {/* MODAL ELIMINAR PAGO */}
      <ModalConfirmacion 
      show={modalConfirmacion} 
      message={<p className="mb-0">¿Deseas eliminar el endoso: <b>{state.numero_endoso}</b>?</p>} 
      handleDelete={ deleteEndoso }
      handleCancel={ handleCloseModalConfirmacion }
      isLoading={state.isLoadingConfirmacion}
      textConfirm={'Si, eliminar endoso'}
      textCancel={'Cerrar'}
      />

      {/* MODAL ELIMINAR ARCHIVO */}
      <ModalConfirmacion 
      show={dataFile.modalDeleteFile} 
      message={<p className="mb-0">¿Deseas eliminar el archivo: <b>{dataFile.nombre}</b>?</p>} 
      handleDelete={ () => goToDeletePoliza(dataFile.id_subida) }
      handleCancel={ () => setDataFile({...state,modalDeleteFile: false}) }
      isLoading={dataFile.isLoadingButton}
      textConfirm={'Si, eliminar archivo'}
      textCancel={'Cerrar'}
      />

      {/* MODAL EDIT PRIMAS */}
      <ModalEditPrimas show={modalEditarPrimas} handleClose={handleCloseModalEditPrimas} />

      {/* MODAL ENDOSOS */}
      <ModalEndosos show={state.modalEndoso} handleClose={handleCloseModalEndoso} reload={getViewContrato} />

      {/* MODAL OBSERVACIONES */}
      <ModalObservacionRecibo 
      data={state.dataRecibo}
      show={state.modalObservacion} 
      handleClose={handleCloseModalObservacion} />
      <ModalObservaciones 
      data={state.dataObservacion}
      show={state.modalObservaciones}
      handleClose={handleCloseModalObservaciones} />

      {/* MODAL MODIFICAR RECIBO */}
      <ModalModificarRecibo 
      data={state.dataRecibo}
      show={state.modalModificarRecibo} 
      handleClose={handleCloseModalModificarRecibo} 
      onSubmit={ () => console.log('submit form') }
      />

      {/* MODAL FECHA DE PAGO */}
      <ModalFechaPago data={state.id_historial} show={state.modalFechaPago} handleClose={ handleCloseModalFechaPago } />

      {/* MODAL VER ENDOSOS */}
      <ModalVisualizarEndoso 
      idEndoso={state.id_endoso}
      show={state.modalVerEndoso} 
      handleClose={ handleCloseModalVerEndoso } 
      data={state.dataEndoso} 
      endoso={state.numero_endoso}
      isLoading={state.isLoadingVerEndoso} 
      reload={getListEndoso}
      />
      {/* MODAL EDITAR FICHA DE CLIENTE */}
      <ModalEditarFicha
      data={state.dataFicha}
      show={state.modalEditarFicha}
      handleClose={handleCloseModalEditarFicha}
      />
      {/* MODAL AGENTES COMPARTIDOS */}
      <ModalAgentesCompartidos 
      data={idPoliza}
      show={state.modalAgentesCompartidos}
      handleClose={handleCloseModalAgentesCompartidos}
      />

    </React.Fragment>
  )
}

const ModalMarcarPago = ({ show, handleClose, dataPoliza,company}) => {

  const stateHome = useSelector( (state) => state.agents.home );
  const { section,arrContrato, isLoadingViewContrato,modalRecibo } = stateHome;
  const dispatch = useDispatch();

  let numeroPoliza = ( typeof arrContrato.configuracion !== 'undefined') ? arrContrato.configuracion.numero_poliza : '';
  let arrFrom;
  if(section===1) arrFrom = 'arrPorPagar'
  if(section===2) arrFrom = 'arrPagados'
  if(section===3) arrFrom = 'arrVencidos'
  if(section===4) arrFrom = 'arrRenovaciones'
  let dataRecibo = stateHome[arrFrom].filter( element => element.numero_poliza == numeroPoliza);

  console.log('stateHome', stateHome);
  console.log('numero_poliza',numeroPoliza);
  console.log('dataRecibo', dataRecibo);

  const { prima_total, numero_poliza, email,  id_historial, nombre_usuario, tipo_pago, id_compania } = dataPoliza;

  const [state, setState] = useState({
    correo: '',
    isLoading: false,
    error: false,
    errorMessage: '',
  })

  useEffect(() => {
    if(show){
      if(typeof dataPoliza.email !== 'undefined'){
        setState({ ...state, correo: dataPoliza.email})
      }
    }
  },[show])

  const marcarPago = () => {

    var formData = new FormData();
    formData.append('id_historial',id_historial);
    formData.append('opt',1);
    formData.append('email',email);
    formData.append('nombre_cliente',nombre_usuario);
    formData.append('numero_poliza',numero_poliza);
    formData.append('tipo_pago',tipo_pago);
    formData.append('agente','');
    formData.append('compania',company);

    fetch('REST/controllers/mainController?opt=marcarPago',{
      method:'POST',
      mode: 'cors',
      body: formData
    })
    .then( response => response.json() )
    .then( response => {

      let arrFrom;
      if(section===1) arrFrom = 'arrPorPagar'
      if(section===2) arrFrom = 'arrPagados'
      if(section===3) arrFrom = 'arrVencidos'
      if(section===4) arrFrom = 'arrRenovaciones'

      dispatch( marcarPagoRecibo( { 
        section : arrFrom,
        poliza : numero_poliza,
      } ) )
      
      setState({ 
        ...state, 
        isLoading: false, 
        error: false,
        errorMessage: '',
      })
      handleClose();
      toast.success( (e) => (
        <p className="mb-0">Marcaste el recibo de: <b>{numero_poliza}</b> como pagado</p>
      ),{
        duration: 4000
      });
    });
  }

  const enviarCorreoPago = () => {
    var formData = new FormData();
    formData.append('id_historial',)
    setDataDb()
  }

  const handleSave = () => {
    if (state.correo == '') {
      setState({ ...state, error: true, errorMessage: 'Ingresa un correo electrónico' });
      return false;
    }
    setState({ ...state, error: false,isLoading: true });
    marcarPago();
  }

  return(
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirmación de pago - Póliza {numero_poliza}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">

                <Form className="mb-3" onSubmit={ (e) =>  e.preventDefault() }>
                  <Form.Group className="mb-3">
                    <Form.Label>Correo electrónico (requerido)</Form.Label>
                    <Form.Control 
                    type="email"
                    placeholder="Ingresa un correo electrónico" 
                    value={state.correo} 
                    onChange={ (e) => {
                      setState({ ...state, correo: e.target.value })
                    } } />
                  </Form.Group>
                </Form>

                {
                  (state.error) && (
                    <Alert variant='danger'>
                      <i className='bi bi-exclamation-triangle-fill'></i> {state.errorMessage}
                    </Alert>
                  )
                }

              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button 
        className="ws-btn-blue-2" 
        onClick={ handleSave }
        disabled={ state.isLoading }
        >
          <i className="bi bi-check-circle-fill"></i> Marcar pago
        </Button>
        <Button
        className="ws-btn-blue-2"
        >
          <i className="bi bi-send"></i> Marcar pago y enviar correo
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalMarcarPagoRecibo = ({ data, show, handleClose}) => {

  const dispatch = useDispatch();
  const [state,setState] = useState({
    correo: '',
    isLoading: true,
    error: false,
    errorMessage: '',
    info : []
  })

  useEffect(()=> {
    if(show){
      prepareInfo();
    }
  },[show])

  const prepareInfo = () =>{
    const formData = new FormData();
    formData.append('id_historial',data);
    getDataDb(formData,'directoryController','prepareInfoFromEmailPayment')
    .then( response => {
      setState({...state,info: response.info, isLoading: false})
    })
  }

  const marcarPago = (opt) => {
    setState({...state, isLoading: true})
    const {numero_poliza,tipo_pago,compania} = state.info;
    const formData = new FormData();
    formData.append('id_historial',data);
    formData.append('opt',opt);
    formData.append('email',state.correo);
    formData.append('nombre_cliente','');
    formData.append('numero_poliza',numero_poliza);
    formData.append('tipo_pago',tipo_pago);
    formData.append('agente','');
    formData.append('compania',compania);
    setDataDb(formData,'mainController','marcarPago')
    .then( response => {
      handleClose();
      setState({ 
        ...state, 
        isLoading: false, 
        error: false,
        errorMessage: '',
      })
      dispatch( updateStatusRecibo({
        id_historial : data,
        status : 1
      }) )
      dispatch( showAlert({
        show: true,
        message: 'Datos guardados correctamente'
      }) )
      console.log(response);
    })
  }

  const handleSave = (type) => {
    if(type === 2){
      if(state.correo===''){
        setState({
          ...state,
          error: true,
          errorMessage : 'Introduce un correo electrónico'
        })
        return false;
      }
    }
    
    marcarPago(type);
  }

  return(
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirmación de pago</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">

                <Form className="mb-3" onSubmit={ (e) =>  e.preventDefault() }>
                  <Form.Group className="mb-3">
                    <Form.Label>Correo electrónico (requerido)</Form.Label>
                    <Form.Control 
                    type="email"
                    placeholder="Ingresa un correo electrónico" 
                    value={state.correo} 
                    onChange={ (e) => {
                      setState({ ...state, correo: e.target.value })
                    } } />
                  </Form.Group>
                </Form>

                {
                  (state.error) && (
                    <Alert variant='danger'>
                      <i className='bi bi-exclamation-triangle-fill'></i> {state.errorMessage}
                    </Alert>
                  )
                }

              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button 
        className="ws-btn-blue-2" 
        onClick={ () => handleSave(1) }
        disabled={ state.isLoading }
        >
          <i className="bi bi-check-circle-fill"></i> Marcar pago
        </Button>
        <Button
        className="ws-btn-blue-2"
        onClick={ () => handleSave(2) }
        disabled={ state.isLoading}
        >
          <i className="bi bi-send"></i> Marcar pago y enviar correo
        </Button>
      </Modal.Footer>
    </Modal>
  )

}

const ModalConfirmacion = ({show, message, handleDelete, handleCancel,isLoading,textConfirm,textCancel}) => {

  const [btnLoading,setBtnLoading] = useState(false);

  useEffect(()=> {
    setBtnLoading(isLoading);
  },[isLoading])

  return(
    <Modal
      show={show}
      onHide={handleCancel}
      size="sm"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirmar</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        {message}
      </Modal.Body>
      <Modal.Footer>
        <Button className="ws-button-light" onClick={handleCancel} disabled={btnLoading} >{textCancel}</Button>
        <Button variant="danger" onClick={handleDelete} disabled={btnLoading} >{textConfirm}</Button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalFaltaPago = ({show,handleClose,dataPoliza,company,showToast}) => {

  const emailRef = useRef(null);
  const emailCcRef = useRef(null);
  const phoneRef = useRef(null);

  const [state,setState] = useState({
    btnEmailLoading: false,
    btnWhatsappLoading: false,
  })

  const handleSubmitFormEmail = (e) =>{
    e.preventDefault();

    if(emailRef.current.value === ''){
      alert('Ingresa un correo electrónico')
      return false
    }

    setState( prevState => ({
      btnEmailLoading: true
    }))

    const { id_historial, phone, nombre_usuario,numero_poliza,tipo_pago } = dataPoliza;

    const formData = new FormData();
    formData.append('id_historial',id_historial);
    formData.append('email',emailRef.current.value);
    formData.append('phone',phone);
    formData.append('copia',emailCcRef.current.value);
    formData.append('nombre_cliente',nombre_usuario);
    formData.append('numero_poliza',numero_poliza);
    formData.append('tipo_pago',tipo_pago);
    formData.append('agente','');
    formData.append('compania',company);
    formData.append('opt',0);
      
    setDataDb(formData,'mainController','faltaPago')
    .then( response => {
      showToast(`Se ha enviado un aviso por falta de pago al correo: ${emailRef.current.value}`)
      setState( prevState => ({
        btnEmailLoading: false
      }))
      console.log(response);
    })
  }

  const handleSubmitFormWhatsapp = (e) =>{
    e.preventDefault();

    if(phoneRef.current.value === ''){
      alert('Ingresa un número de WhatsApp')
      return false
    }

    setState( prevState => ({
      btnWhatsappLoading: true
    }))

    const { id_historial, phone, nombre_usuario,numero_poliza,tipo_pago } = dataPoliza;

    const formData = new FormData();
    formData.append('id_historial',id_historial);
    formData.append('email',emailRef.current.value);
    formData.append('phone',phone);
    formData.append('copia',emailCcRef.current.value);
    formData.append('nombre_cliente',nombre_usuario);
    formData.append('numero_poliza',numero_poliza);
    formData.append('tipo_pago',tipo_pago);
    formData.append('agente','');
    formData.append('compania',company);
    formData.append('opt',1);
      
    setDataDb(formData,'mainController','faltaPago')
    .then( response => {
      showToast(`Se ha enviado un aviso por falta de pago al Whatsapp: ${phoneRef.current.value}`)
      setState( prevState => ({
        btnWhatsappLoading: false
      }))
      console.log(response);
    })
  }
  

  return(
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Notificación de falta de pago</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <p>¿Deseas notificar a tu cliente sobre falta de pago?</p>
        <Form onSubmit={handleSubmitFormEmail}>
          <Form.Group>
            <Form.Label>*Esta acción solo enviará un email</Form.Label>
            <Form.Control ref={emailRef} defaultValue={dataPoliza.email} className="mb-2" type="email" placeholder="Ingresa un correo electrónico" required />
            <Form.Control ref={emailCcRef} className="mb-2" type="email" placeholder="Ingresa un correo electrónico copia" />
            <Button 
            type="submit" 
            className="ws-btn-blue-2 mb-2" 
            disabled={ (state.btnEmailLoading) ? true : false }
            ><i className="bi bi-send"></i> { (state.btnEmailLoading) ? 'Enviando...' : 'Enviar Aviso' }</Button>
          </Form.Group>
        </Form>
        <hr/>
        <Form onSubmit={handleSubmitFormWhatsapp}>
          <Form.Group>
            <Form.Label>*Notificar vía WhatsApp</Form.Label>
            <Form.Control ref={phoneRef} defaultValue={dataPoliza.phone} className="mb-2" type="text" onChange={ (e) => { validatePhone(e) } } required />
            <Button 
            type="submit" 
            className="ws-btn-blue-2 mb-2" 
            disabled={ (state.btnWhatsappLoading) ? true : false }
            ><i className="bi bi-send"></i> { (state.btnWhatsappLoading) ? 'Enviando...' : 'Enviar Aviso Vía Whatsapp' }</Button>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button className="ws-button-light" onClick={handleClose}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalCancelarPoliza = ({initState,initSetState,show,handleClose,dataPoliza,showToast,section}) => {

  const motivoRef = useRef(null);
  const descripcionRef = useRef(null);

  const [state,setState] = useState({
    btnEliminarLoading: false,
  })

  const handleSubmitCancelarPoliza = (e) =>{
    e.preventDefault();

    if(motivoRef.current.value === ''){
      alert('Selecciona una opción')
      return false
    }

    setState( prevState => ({
      btnEliminarLoading: true
    }))

    const { id_contrato,numero_poliza } = dataPoliza;

    const formData = new FormData();
    formData.append('id_contrato',id_contrato);
    formData.append('val',descripcionRef.current.value);
    formData.append('option',motivoRef.current.value);

    console.log(id_contrato);
    console.log(descripcionRef.current.value)
    console.log(motivoRef.current.value);
      
    deleteDataDb(formData,'directoryController','setCancelPoliza')
    .then( response => {
      showToast(`Haz cancelado la póliza con éxito`)
      setState( prevState => ({
        btnEliminarLoading: false
      }))

      let arrFrom;
      if(section===1) arrFrom = 'arrPorPagar'
      if(section===2) arrFrom = 'arrPagados'
      if(section===3) arrFrom = 'arrVencidos'
      if(section===4) arrFrom = 'arrRenovaciones'

      initSetState({
        ...initState,
        [arrFrom] : initState[arrFrom].filter( element => { 
          if(element.id_contrato!==id_contrato){
            return element
          } 
        } )
      })
      handleClose();
      console.log(response);
    })
  }

  return(
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Eliminar contrato</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Form onSubmit={handleSubmitCancelarPoliza}>
          <Form.Group>
            <Form.Label>Estás a punto de eliminar un contrato, si aceptas también será borrado su historial de pagos.</Form.Label>
            <Form.Select ref={motivoRef} defaultValue="" className="mb-2" type="email" required>
              <option value="" disabled>Elige un motivo</option>
              <option value="1">VENTA DE VEHÍCULO</option>
              <option value="2">SINIESTRO</option>
              <option value="3">CAMBIO DE UNIDAD</option>
              <option value="4">A SOLICITUD DEL ASEGURADO</option>
              <option value="5">FALTA DE PAGO</option>
              <option value="6">SERVICIO</option>
              <option value="7">PRECIO</option>
              <option value="0">OTRO</option>
            </Form.Select>
            <Form.Control ref={descripcionRef} as="textarea" className="mb-3" rows="5" placeholder="Escribe el motivo de la cancelación..." />
            <Button 
            type="submit" 
            className="btn-danger mb-2" 
            disabled={ (state.btnEliminarLoading) ? true : false }
            ><i className="bi bi-trash"></i> { (state.btnEliminarLoading) ? 'Eliminando...' : 'Eliminar' }</Button>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button className="ws-button-light" onClick={handleClose}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  )
}

export {
  ModalFilter,
  ModalEditPrimas,
  ModalEndosos,
  ModalRecibos,
  ModalMarcarPago,
  ModalMarcarPagoRecibo,
  ModalConfirmacion,
  ModalFaltaPago,
  ModalCancelarPoliza,
}